export const workingDays = [
    { day: 'MONDAY', startTime: null, endTime: null, workingDay: true },
    { day: 'TUESDAY', startTime: null, endTime: null, workingDay: true },
    { day: 'WEDNESDAY', startTime: null, endTime: null, workingDay: true },
    { day: 'THURSDAY', startTime: null, endTime: null, workingDay: true },
    { day: 'FRIDAY', startTime: null, endTime: null, workingDay: true },
    { day: 'SATURDAY', startTime: null, endTime: null, workingDay: true },
    { day: 'SUNDAY', startTime: null, endTime: null, workingDay: true },
];

//This is used only once. After the clinic saves the data it's fetched and rendered from the backend.